import {CheckboxV2, Box, Typography} from "@/elements";
import {queryParamsInitial} from "../../store";

export const UserHeader = ({setSearchParams, searchParams}) => {

    const onChangeCheckedIsDelete = event => {
        searchParams.set('page', String(queryParamsInitial.page))
        searchParams.set('isShowDeletedItems', String(Number(event.target.checked)))

        setSearchParams(searchParams, { replace: true })
    }

    return (
        <Box direction="column" margin="10px 0px" gap="10px">
            <Box justify="space-between" width="100%" align="center">
                <Typography variant="h6">Users</Typography>

                <Box display="flex" gap="16px" align="center">
                    <CheckboxV2
                        label="Show deleted users"
                        checked={searchParams.isShowDeletedItems}
                        onChange={onChangeCheckedIsDelete}
                    />
                </Box>
            </Box>
        </Box>
    )
}